var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 109,
    viewBox: "0 0 112 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5362 103.328C78.906 97.8698 99.8436 76.9322 105.302 56.5624C107.955 46.6603 106.462 38.7153 101.887 33.7915L88.2899 20.1946L22.2673 86.2171L22.2756 86.423L34.9495 99.0969C39.7858 104.303 48.0673 106.133 58.5362 103.328Z",
    fill: "url(#paint0_linear_1191_32109)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6697 43.9307C87.2116 64.3005 66.274 85.2382 45.9042 90.6962C25.5345 96.1543 13.4461 84.066 18.9042 63.6962C24.3623 43.3264 45.2999 22.3887 65.6697 16.9307C86.0395 11.4726 98.1278 23.5609 92.6697 43.9307Z",
    fill: "url(#paint1_linear_1191_32109)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.695 39.6366C100.865 68.8566 70.8308 98.891 41.6108 106.72C12.3909 114.55 -4.94949 97.2095 2.87997 67.9896C10.7094 38.7697 40.7439 8.73522 69.9638 0.905761",
    stroke: "#97D897",
    strokeWidth: 0.367749
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.846 16.8764C112.081 18.1086 111.35 20.8396 109.215 22.9762L62.3791 69.8388C61.3533 70.8652 60.1339 71.6143 58.9894 71.9213C57.8448 72.2282 56.869 72.0678 56.2765 71.4754L48.1661 63.365C46.9328 62.1317 47.6647 59.4004 49.8007 57.2644C51.9368 55.1283 54.6681 54.3965 55.9013 55.6297L57.9947 57.7231L104.538 10.5684L110.846 16.8764Z",
    fill: "#74C374"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.53 10.5604C105.764 11.7925 105.034 14.5235 102.898 16.6601L56.0627 63.5228C55.0369 64.5492 53.8175 65.2983 52.673 65.6052C51.5284 65.9122 50.5525 65.7518 49.9601 65.1594L41.8497 57.0489C40.6164 55.8157 41.3483 53.0843 43.4843 50.9483C45.6204 48.8123 48.3517 48.0804 49.5849 49.3137L55.4613 55.19L98.4285 12.1981C100.564 10.0614 103.296 9.32819 104.53 10.5604Z",
    fill: "#BFF2BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.39 10.5604C100.624 11.7925 99.8938 14.5235 97.7584 16.6601L50.9228 63.5228C49.897 64.5492 48.6776 65.2983 47.5331 65.6052C46.3885 65.9122 45.4127 65.7518 44.8202 65.1594L36.7098 57.0489C35.4765 55.8157 36.2084 53.0843 38.3444 50.9483C40.4805 48.8123 43.2118 48.0804 44.445 49.3137L50.3214 55.19L93.2886 12.1981C95.424 10.0614 98.1557 9.32819 99.39 10.5604Z",
    stroke: "white",
    strokeWidth: 0.367749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1191_32109",
    x1: 96.4878,
    y1: 63.7959,
    x2: 58.882,
    y2: 93.9341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74CA74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1191_32109",
    x1: 30.1241,
    y1: 94.6716,
    x2: 70.6794,
    y2: 18.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91DB91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.c4edfede1661d3a839d10ab6eca0d6d1.svg";
export { ForwardRef as ReactComponent };